import React, { useContext } from 'react';
import styled from 'styled-components';

import { DarkModeContext } from './context/DarkModeContext';
import {
	FaBehanceSquare,
	FaGithubSquare,
	FaTwitterSquare
} from 'react-icons/fa';
import { COLORS } from './common/constants';

const Footer = () => {
	const { isDarkModeOn } = useContext(DarkModeContext);
	return (
		<Links>
			<Link>
				<a
					href='https://www.behance.net/wondasom'
					target='_blank'
					rel='noopener noreferrer'
				>
					<FaBehanceSquare
						color={isDarkModeOn ? COLORS.mainAqua : COLORS.mainBlue}
						size='2.5rem'
					></FaBehanceSquare>
				</a>
			</Link>
			<Link>
				<a
					href='https://github.com/wondasom'
					target='_blank'
					rel='noopener noreferrer'
				>
					<FaGithubSquare
						color={isDarkModeOn ? COLORS.mainAqua : COLORS.mainBlue}
						size='2.5rem'
					></FaGithubSquare>
				</a>
			</Link>
			<Link>
				<a
					href='https://twitter.com/dasom_won'
					target='_blank'
					rel='noopener noreferrer'
				>
					<FaTwitterSquare
						color={isDarkModeOn ? COLORS.mainAqua : COLORS.mainBlue}
						size='2.5rem'
					></FaTwitterSquare>
				</a>
			</Link>
		</Links>
	);
};

export default Footer;

// 🎨 Styled Components
const Links = styled.ul`
	width: 90%;
	display: flex;
	flex-direction: row-reverse;
	align-items: center;
	padding: 4rem 0;
`;

const Link = styled.li`
	padding: 0 0 0 0.6rem;
`;
